import React, { Component } from 'react'
import { List, Icon, Button, Popconfirm, notification } from "utils/ui";
import { deleteNote } from '../api_calls/user';
import { observer } from 'mobx-react';

@observer(['UserStore', 'AuthStore'])
class Notes extends Component {
    constructor(props) {
        super(props);
        this.state = {deletingNotify: ""}
        this.confirmDelete = this.confirmDelete.bind(this);
    }
    confirmDelete(note) {
        const { UserStore, AuthStore } = this.props;
        notification.open({
            message: 'Deleting your note',          
            icon: <Icon type="loading" style={{ color: '#108ee9' }} />,
            duration: 1
          });
      
        console.log("key" + note);
        let user = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
        deleteNote(user, note, AuthStore.userAuth.auth.accessToken).then(() => {
            UserStore.refreshUser(AuthStore.userAuth.auth.accessToken);
        });
    }
    render() {
        return (
            <div className="notes-panel AppFont">        
                <List
                    size="large"
                    header={<div className="notes-panel-header NoteFont">Notes</div>}
                    className="notes-panel-list"
                    bordered
                    dataSource={this.props.notes}
                    renderItem={(note, index) => (
                        <List.Item className="notes-panel-item" key={`${note}-${index}`}>
                            <div className="notes-panel-text NoteFont">{note}</div>
                            <Popconfirm title="Are you sure you want to delete this note?" okText="Yes" onConfirm={this.confirmDelete.bind(this, note)} cancelText="No">
                                <Button className="AppFont ui-btn-danger-icon notes-panel-delete-btn"><Icon style={{ fontSize: "12pt" }} type="delete" /></Button>
                            </Popconfirm>
                        </List.Item>
                    )}
                />
            </div>
        )
    }
}
export default Notes;
